import type { SqliteExecutor } from '@littlebird/local-db';

export function createElectronExecutor(): SqliteExecutor {
  return {
    execute: (request) => window.localDbApi.execute(request),
    reset: () => window.localDbApi.reset(),
    close: async () => {},
  };
}
